import Common from './Common.js';

const singleton = Symbol();
const singletonEnforcer = Symbol();

class WinResize{

    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw "Cannot construct singleton"
        }

        this.comm = Common.instance;
        this.callbackFnList = [];
    }

    static get instance() {
        if(!this[singleton]) {
            this[singleton] = new WinResize(singletonEnforcer);
        }
        return this[singleton];
    }

    init(){
        $(window).on( 'resize', (ev)=>{
            this.callbackFnList.forEach( _fn => _fn() );
        })/*.trigger( 'resize' )*/;
    }

    addCallback(_fn){
        this.callbackFnList.push(_fn);
    }

}

export default WinResize;



// WEBPACK FOOTER //
// ./WinResize.js